export const AVAILABLE_MAGNIFICATIONS = [1.25, 2.5, 5, 10, 20, 40];
export const DEFAULT_MAGNIFICATION = AVAILABLE_MAGNIFICATIONS[1];
const MIN_AVAILABLE_MAGNIFICATION = AVAILABLE_MAGNIFICATIONS[0];

export function getMagnificationForZoom(image, zoom) {
  if (!image || !image.magnification) {
    return null;
  }
  return Math.pow(2, zoom - image.zoom) * image.magnification;
}

export function getAvailableMagnifications(image) {
  let maxMagnification = Number(image?.magnification);
  if (!maxMagnification || maxMagnification <= 0) {
    return AVAILABLE_MAGNIFICATIONS;
  }

  let magnifications = [];
  for (let mag = maxMagnification; mag >= MIN_AVAILABLE_MAGNIFICATION; mag /= 2) {
    magnifications.unshift(Number(mag.toFixed(4)));
  }

  return magnifications.length ? magnifications : [maxMagnification];
}

export function getZoomForMagnification(image, magnification, fallbackZoom = null) {
  if (!image || !image.magnification) {
    return fallbackZoom;
  }
  return image.zoom + Math.log2(magnification / image.magnification);
}
